<style lang='less' scoped>
    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    li{
        list-style: none;
    }
    .aboutCloud{
        max-width: 1440px;
        width: 100%;
        margin: 0 auto;
        padding: 28px 0 0;
        @media screen and (max-width: 1000px) {
            >div.topBg{
                display: block;
                padding: 0;
                text-align: center;
                >img{
                    display: none;
                }
                >div.topBg-title{
                    text-align: center;
                    padding-top: 40px;
                    span{
                        font-size: 14px;
                    }
                    p{
                        font-size: 20px;
                    }
                }
            }
        }
        .topBg{
            width: 100%;
            height: 195px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            position: relative;
            background: url('../../assets/index_bg1.png') no-repeat;
            background-size: 100% 100%;
            >div{
                color: #fff;
                text-align: left;
                >span{
                    display: inline-block;
                    padding: 0 0 13px;
                    border-bottom: 1px solid #fff;
                    font-size: 18px;
                }
                >p{
                    margin-top: 16px;
                    font-size: 24px;
                }
            }
            >img{
                // position: absolute;
                // top: 10px;
                // right: 210px;
                position: relative;
                top: 25px;
                // width: 390px;
                // height: 225px;
            }
        }
        .introduction{
            margin-top: 45px;
            width: 100%;
            .intTitle{
                .title{
                    font-size: 25px;
                    font-weight: bold;
                    color: #333;
                }
                >div{
                    width: 36px;
                    height: 1.5px;
                    margin: 3px auto 7px;
                    background-color: #F36800;
                }
                .enTitle{
                    color: #B5B5B5;
                    letter-spacing:1.5px;
                }
            }
            ul{
                width: 100%;
                padding: 60px 21px 0;
                display: flex;
                flex-wrap: wrap;
                @media screen and (max-width: 768px) {
                    li.aboutCloud-item {
                        display: unset;
                        margin-bottom: 60px;
                        text-align: center;
                        >img{
                            width: 150px;
                            height: calc(114/207*150px);
                            margin: 0 auto;
                        }
                        >div{
                            text-align: left;
                            width: 220px;
                            margin: 0 auto;
                        }
                    }
                }
                @media screen and (max-width: 500px) {
                    li.aboutCloud-item {
                        width: 100%;
                        margin-bottom: 40px;
                        display: unset;
                        text-align: center;
                        >img{
                            width: 100px;
                            height: calc(114/207*150px);
                            margin: 0 auto;
                            margin-bottom: 20px;
                        }
                        >div{
                            text-align: left;
                            max-width: 400px;
                            width: 100%;
                        }
                    }
                }
                li{
                    width: 50%;
                    // margin: 0 175px 76px 0;
                    text-align: left;
                    display: flex;
                    &:nth-of-type(2n){
                        margin: 0 0 76px 0;
                    }
                    >img{
                        width: 207px;
                        height: 114px;
                    }
                    >div{
                        margin-left: 20px;
                        width: 375px;
                        >p{
                            display: flex;
                            align-items: center;
                            font-size: 20px;
                            font-weight: bold;
                            color: #333;
                            margin-bottom: 15px;
                            .dian{
                                display: inline-block;
                                width: 7px;
                                height: 7px;
                                background-color: #000;
                                border-radius: 50%;
                                margin-right: 8px;
                            }
                        }
                        >div{
                            p{
                                line-height: 30px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
<template>
    <div class="aboutCloud">
        <div class="topBg">
            <div class="topBg-title">
                <span>柜柜云仓，全球板材工业物联网：全国5大总仓，2大海外仓</span>
                <p>1张起售，就近发货，包退包换</p>
            </div>
            <img src="../../assets/index_bg3.png" alt="">
        </div>
        <div class="introduction">
            <div class="intTitle">
                <p class="title">门窗柜-云工厂平台介绍</p>
                <div></div>
                <p class="enTitle">Introduction&nbsp;of&nbsp;GUIGUI&nbsp;cloud&nbsp;warehouse</p>
            </div>
            <ul>
                <li v-for="item in list" :key="item.id" class="aboutCloud-item">
                    <img :src="item.indexImg" alt="">
                    <div>
                        <p>
                            <span class="dian"></span>
                            <span>{{item.title}}</span>
                        </p>
                        <div>
                            <p v-for="(value,index) in item.content" :key="index">{{value}}</p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            Back: require('../../assets/index_bg1.png'),
            list:[
                    {
                        id:1,
                        indexImg:require('../../assets/aboutCloud1.png'),
                        title:'云仓库-品质保障',
                        content:[
                            '全国1000家本地化工厂，都是经过信息化改造的工厂，服务公开，经得住消费者考验。',
                            '由于每个业主都是量身定制，难免有破损差错，本地化工厂能解决快速补货，维修等工作。',
                            '工厂材料由云仓提供，材料可以溯源，品质可以保障。'
                        ]
                    },
                    {
                        id:2,
                        indexImg:require('../../assets/aboutCloud2.png'),
                        title:'云工厂-本地生产',
                        content:[
                            '柜柜云仓全国五大总仓，为全球300多个分仓匹配优质材料供应商和最合适的物流公司。',
                            '五大总仓包含:西部成都、东部临沂、北部沈阳、中部九江、南部南宁。',
                            '总仓由云仓平台投资建设，依据大数据开发产品、利用信息化打造配送、仓库、培训与一体的示范基地。'
                        ]
                    },
                    {
                        id:3,
                        indexImg:require('../../assets/aboutCloud3.png'),
                        title:'社区店-上门服务',
                        content:[
                            '社区服务点就是消费者邻居，靠口碑才能生存。就近服务，测量、安装、维修都方便。售后也有长期保障。',
                            '社区网点有多年从业经验，经过平台培训，都具备一定的设计能力，能满足用户量身定制的需求。',
                            '社区店面有样品，方便用户现场体验，选材，更放心。'
                        ]
                    },
                    {
                        id:4,
                        indexImg:require('../../assets/aboutCloud4.png'),
                        title:'总平台-服务监管',
                        content:[
                            '用户的评价都是公开透明的，让消费者监督服务单位。',
                            '平台也会对服务不好，加工工艺不好的单位清除，保障消费者的权益。',
                            '平台有投诉通道，消费者维权通道，让业主买的放心。'
                        ]
                    },
                    {
                        id:5,
                        indexImg:require('../../assets/aboutCloud5.png'),
                        title:'省环节-节约成本',
                        content:[
                            '云仓材料开发都是经过大数据分析所得，减少了产品是错的环节，生下来的钱都回馈消费者。',
                            '材料没有中间商赚差价，工厂没有门店的房租成本和人工成本，极大的降低中间成本。',
                            '我们的报价方式都是材料成本+加工费+服务费，每个环节都透明，为消费者定制物美价廉的定制产品。'
                        ]
                    },
                    {
                        id:6,
                        indexImg:require('../../assets/aboutCloud6.png'),
                        title:'使命感-动力不断',
                        content:[
                            '用108年，改善人类居住环境!使我们多年来—直践行的使命。我们是—支掌握现代科技，有梦想，情怀的年轻团队。',
                            '从定制家居开始，改善老百姓的居家环境，实现自身价值。让普通老百姓都能买得起高品质的定制产品，产品功能贴心，材料更环保。',
                            '用更先进的科技手段，更合理的利益分配，更科学的供应链流程，造福百姓，共同创造美好生活'
                        ]
                    },
                ]
        }
    }
}
</script>
